import {
    CANCELLED_INVOICE,
    ID_ACCOUNTED, ID_CANCELLED,
    ID_OPEN,
    ID_REISSUED,
    ID_SENT, ID_SUB_OOFC_PENDING, ID_SUB_OOFC_UNPAID,
    ID_TO_SEND,
    ID_UNACCOUNTED,
    SENT_FOR_ACCOUNTED,
    TO_BE_ACCOUNTED
} from "../constants/InvoicesStatuses";
import ColouredChip from "../../../component/ColouredChip";
import {
    COLOR_ACCOUNTED, COLOR_CANCELLED,
    COLOR_OPEN,
    COLOR_REISSUED,
    COLOR_SENT,
    COLOR_TO_SEND,
    COLOR_UNACCOUNTED
} from "../constants/InvoicesColors";

export function showStatusColumn(status: string) {
    switch (status) {
        case ID_OPEN: {
            return {
                component: () => <ColouredChip name={ID_OPEN} color={COLOR_OPEN}/>
            };
        }
        case ID_TO_SEND: {
            return {
                component: () => <ColouredChip name={TO_BE_ACCOUNTED} color={COLOR_TO_SEND}/>
            };
        }
        case ID_SENT: {
            return {
                component: () => <ColouredChip name={SENT_FOR_ACCOUNTED} color={COLOR_SENT}/>
            };
        }
        case ID_ACCOUNTED: {
            return {
                component: () => <ColouredChip name={ID_ACCOUNTED} color={COLOR_ACCOUNTED}/>
            };
        }
        case ID_UNACCOUNTED: {
            return {
                component: () => <ColouredChip name={ID_UNACCOUNTED} color={COLOR_UNACCOUNTED}/>,
            };
        }
        case ID_REISSUED: {
            return {
                component: () => <ColouredChip name={ID_REISSUED} color={COLOR_REISSUED}/>,
            };
        }
        case ID_CANCELLED: {
            return {
                component: () => <ColouredChip name={CANCELLED_INVOICE} color={COLOR_CANCELLED}/>,
            };
        }
        case ID_SUB_OOFC_UNPAID: {
            return {
                component: () => <ColouredChip name={ID_SUB_OOFC_UNPAID} color={COLOR_CANCELLED}/>,
            };
        }
        case ID_SUB_OOFC_PENDING: {
            return {
                component: () => <ColouredChip name={ID_SUB_OOFC_PENDING} color={COLOR_TO_SEND}/>,
            };
        }
    }
}
